import { render, staticRenderFns } from "./PapInt.vue?vue&type=template&id=12c6a712&scoped=true"
import script from "./PapInt.vue?vue&type=script&lang=js"
export * from "./PapInt.vue?vue&type=script&lang=js"
import style0 from "./PapInt.vue?vue&type=style&index=0&id=12c6a712&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c6a712",
  null
  
)

export default component.exports